import { NavLink } from 'react-router-dom';
import { 
  Home,
  User,
  Settings,
  Search,
  BarChart3,
  LogOut,
  Users,
  Building2,
  Library,
  NotebookTabs,
  Database
} from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';

const NavBar = ({ isOpen }) => {
  const { user, logOut } = useAuth();
  const isContractUser = user?.roles?.includes('contract');

  const navItems = isContractUser ? [
    { path: '/contract', label: 'Contract', icon: NotebookTabs },
  ] : [
    { path: '/', label: 'Home', icon: Home },
    { path: '/dashboard', label: 'Vault', icon: Library },
    { path: '/lookup', label: 'Lookup', icon: Search },
    // { path: '/reprice', label: 'Reprice', icon: GitBranch },
    // { path: '/audit', label: 'Audit', icon: FileSearch },
    { path: '/analytics', label: 'Analytics', icon: BarChart3 },
    ...(user?.roles?.includes('admin') ? [{ path: '/team', label: 'Team', icon: Users }] : []),
    ...(user?.roles?.includes('superadmin') ? [{ path: '/organizations', label: 'Employer Group', icon: Building2 }] : []),
    { path: '/contract', label: 'Contract', icon: NotebookTabs },
    { path: '/data-feed', label: 'Data Feed', icon: Database },
    { path: '/settings', label: 'Settings', icon: Settings },
    { path: '/profile', label: 'Profile', icon: User },
  ];

  const getTooltipProps = (label) => {
    return {
      'data-tooltip-id': 'navbar-tooltip',
      'data-tooltip-content': label,
      'data-tooltip-place': 'right',
      'data-tooltip-offset': isOpen ? 0 : -188
    };
  };

  return (
    <nav className={`navbar ${isOpen ? 'open' : ''}`}>
      <div style={{paddingBottom: '22px'}} className="nav-menu">
        {navItems.map((item) => (
          <div key={item.path} className="nav-item-wrapper">
            <NavLink
              to={item.path}
              className={({ isActive, location }) => {
                // For Vault button, check if path is /dashboard or starts with /file/
                if (item.path === '/dashboard') {
                  return `nav-item ${(isActive || window.location.pathname.startsWith('/file/')) ? 'active' : ''}`;
                }
                return `nav-item ${isActive ? 'active' : ''}`;
              }}
              {...getTooltipProps(item.label)}
            >
              <item.icon className="nav-icon" size={20} />
              <span className="nav-title">{item.label !== 'Home' ? item.label : ''}</span>
            </NavLink>
          </div>
        ))}

        <div className="nav-item-wrapper">
          <button
            onClick={logOut}
            className="nav-item"
            style={{width: '100%',justifyContent: 'flex-start',border:0}}
            {...getTooltipProps('Logout')}
          >
            <LogOut className="nav-icon" size={20} />
            <span className="nav-title">Logout</span>
          </button>
        </div>
        
      </div>
    </nav>
  );
};

export default NavBar; 
